<template>
  <alert-message :type="alert.type" :message="alert.message" v-if="showAlert"></alert-message>
  <el-card class="box-card detail-screen mb-25">
    <el-row class="title">
      <div class="box-staff">
        <el-avatar :size="100" :src="staff.avatar_image_url"/>
        <div class="text-left lh-100 font-weight-700 name">{{ staff.name }}</div>
      </div>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.staff_id') }}</span></el-col>
      <el-col :span="19"><span>{{ staff.id }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.company_name') }}</span></el-col>
      <el-col :span="19"><span>{{ staff.company.name }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.shop_name') }}</span></el-col>
      <el-col :span="19"><span>{{ staff.shop.name }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.occupation') }}</span></el-col>
      <el-col :span="19"><span>{{ staff.occupation }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.nickname') }}</span></el-col>
      <el-col :span="19"><span>{{ staff.nickname }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.birthday') }}</span></el-col>
      <el-col :span="19"><span>{{ staff.birthday ? $dayjs(staff.birthday).format('YYYY/MM/DD') : '' }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.gender') }}</span></el-col>
      <el-col :span="19">
        <span>{{ staff.gender_name }}</span><br>
      </el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('shops.detail_fields.mail_address') }}</span></el-col>
      <el-col :span="19"><span>{{ staff.mail_address }}</span></el-col>
    </el-row>
    <div class="group-input">
      <el-row>
        <el-col :span="12">
          <span>{{ $t('staff.account_info') }}</span>
        </el-col>
        <el-col :span="12" class="reset-account"  v-if="site != $siteType.site_partner && staff.partner_user.login_type !== $loginType.line && staff.mail_address">
          <span @click="resetAccount">{{ $t('reset_account_info')}}</span>
        </el-col>
      </el-row>
    </div>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.register_date') }}</span></el-col>
      <el-col :span="19"><span>{{ formatDate(this.staff.created_at) }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.last_login_date') }}</span></el-col>
      <el-col :span="19"><span>{{ formatDate(this.staff.user_partner_last_login_datetime) }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle" v-if="staff.partner_user.login_type !== $loginType.line">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.login_id') }}</span></el-col>
      <el-col :span="19"><span>{{ staff.login_id }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle" v-if="staff.partner_user.login_type !== $loginType.line">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.password') }}</span></el-col>
      <el-col :span="19"><span>**********</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.status') }}</span></el-col>
      <el-col :span="19"><span>{{ staff.status_name }}</span></el-col>
    </el-row>
    <el-row class="row-data" align="middle" v-if="role != $userRole.partner.staff">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.order_number') }}</span></el-col>
      <el-col :span="19"><span>{{ staff.order_number }}</span></el-col>
    </el-row>
    <div class="group-input"><span>{{ $t('staff.description_reply') }}</span></div>
     <el-row class="row-data" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.description') }}</span></el-col>
      <el-col :span="19"><span v-html="formatTextShowUrl(staff.description_formated)" class="break-word"></span></el-col>
    </el-row>
     <el-row class="row-data last-row" align="middle">
      <el-col :span="5"><span class="label">{{ $t('staff.detail_fields.message_text') }}</span></el-col>
      <el-col :span="19"><span v-html="formatTextShowUrl(staff.message_text_formated)" class="break-word"></span></el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="text-center mt-25">
       <el-button type="primary" @click="redirectEdit" class="btn btn-edit">{{ $t('update') }}</el-button>
       <el-button @click="back" class="btn btn-back" v-if="role != $userRole.partner.staff">{{ $t('back') }}</el-button>
      </el-col>
    </el-row>
  </el-card>
  <el-card class="box-card detail-screen" v-if="role != $userRole.partner.staff">
    <el-row class="title">
      <el-col :span="24">
        <label class="font-weight-700">{{ $t('staff.earn_kokoron_detail.title') }}</label>
        <span class="btn-open-close" @click="handleScreenEarnDetail">
          {{ textBtn }}
        </span>
      </el-col>
    </el-row>
    <el-divider />
    <div v-if="showEarnScreenDetail">
      <form-search-date @get-point-and-money="getPointAndMoney"></form-search-date>
      <el-divider />
      <div class="main">
        <label class="title">{{ $t('earn_kokoro') }}</label>
        <p class="content">
          <span class="point">{{ point }}<span class="pt">{{ $t('kokoron') }}</span></span>
          <span class="money">({{ money }})</span>
        </p>
      </div>
    </div>
  </el-card>
  <dialog-reset-account
    v-if="isOpenPopupReset" :openFormReset="true"
    :email="this.staff.mail_address"
    @is-close-popup-reset="handleClosePopupReset"
    @reset-account="handleResetAccount">
  </dialog-reset-account>
</template>
<script>
  import { resetAccount } from '../../api/common'
  import { getPointAndMoney } from '../../api/staff'
  import { Checkurl } from '../../common'
  import { CURRENT_YEAR, CURRENT_MONTH, CURRENT_DAY, LOGIN_TYPE } from '../../constants'

  export default {
    props: {
      staff: { type: Object, required: true, default: {} },
      urls: { type: Object, required: true, default: {} },
      site: { type: Number, required: false },
      role: { type: Number, required: false }
    },
    data() {
      return {
        isOpenPopupReset: false,
        textBtn: this.$t('staff.earn_kokoron_detail.close'),
        showEarnScreenDetail: true,
        point: '',
        money: '',
        showAlert: false,
        alert: {
          type: '',
          message: ''
        }
      }
    },
    methods: {
      formatTextShowUrl(text) {
        return Checkurl(text);
      },
      formatDate(dateTime) {
        return (dateTime) ? this.$dayjs(dateTime).format('YYYY/MM/DD') : '';
      },
      resetAccount() {
        this.isOpenPopupReset = true;
      },
      back() {
         window.location.href = this.urls.index;
      },
      redirectEdit() {
        window.location.href = this.urls.edit;
      },
      handleClosePopupReset() {
        this.isOpenPopupReset = false;
      },
      handleResetAccount() {
        document.querySelector(".el-dialog__body").classList.add("disabled");
        resetAccount(this.staff.mail_address, this.staff.partner_user.login_id, this.$userRole.partner.staff)
        .then(response => response.json())
        .then(response => {
          if (response.status_code === this.$httpStatus.success) {
            this.showAlert = true;
            this.alert = { type: 'completed', message: this.$t('reset_account_completed', [this.staff.mail_address]) }
          }
        })
        .finally(() => {
          document.querySelector(".el-dialog__body").classList.remove("disabled");
          this.isOpenPopupReset = false;
        });
      },
      handleScreenEarnDetail(periodStart, periodEnd) {
        this.showEarnScreenDetail = !this.showEarnScreenDetail;
        this.textBtn = this.showEarnScreenDetail ?
                      this.$t('staff.earn_kokoron_detail.close')
                      : this.$t('staff.earn_kokoron_detail.open');
      },
      getPointAndMoney(data) {
        getPointAndMoney(this.staff.id, data)
        .then(response => response.json())
        .then(response => {
          this.point = response.data.point;
          this.money = response.data.money;
        })
      }
    },

    created() {
      const period_start = this.$dayjs(`${CURRENT_YEAR}-${CURRENT_MONTH}-01`).format('YYYY-MM-DD');
      const period_end = this.$dayjs(`${CURRENT_YEAR}-${CURRENT_MONTH}-${CURRENT_DAY}`).format('YYYY-MM-DD');
      const data = { period_start: period_start, period_end: period_end};
      if (this.role != this.$userRole.partner.staff) {
        this.getPointAndMoney(data);
      }
    },
  }
</script>
<style lang="scss" scoped>
  .detail-screen {
    .el-divider--horizontal {
      margin: 0;
    }
    .title {
      font: normal normal normal 15px/33px Kozuka Gothic Pr6N;
      letter-spacing: 1.5px;
      color: #000000;
      padding-bottom: 0px;
      .btn-open-close {
        font: normal normal normal 11px/20px Kozuka Gothic Pr6N;
        letter-spacing: 1.1px;
        color: #969696;
        margin-left: 20px;
        cursor: pointer;
      }
      .box-staff {
        display: flex;
        align-items: center;
        width: 100%;
        padding-bottom: 20px;
        .el-avatar {
          width: 100px;
        }
        .name {
          width: calc(100% - 100px);
          padding-left: 35px;
        }
      }
    }
    .main {
      color: #000000;
      padding-top: 10px;
      .title {
        font: normal normal normal 13px/29px Kozuka Gothic Pr6N;
        letter-spacing: 1.3px;
        font-weight: 700;
      }
      .content {
        .point {
          font: normal normal bold 25px/23px Futura;
          letter-spacing: 0.25px;
          .pt {
            letter-spacing: 1.7px;
            font-size: 17px;
            padding-left: 8px;
          }
        }
        .money {
          font: normal normal bold 13px/29px Kozuka Gothic Pr6N;
          letter-spacing: 1.3px;
          margin-left: 10px;
        }
      }
    }
  }
</style>
